<template>
    <page-header-wrapper>
        <a-card :bordered="false">
            <div class="table-operations">
                <table-setting :style="{ float: 'right' }" :table-size.sync="tableSize" v-model="columns"
                    :refresh-loading="loading" @refresh="getList" />
                <a-button type="primary" @click="$refs.createForm.handleAdd()"
                    v-hasPermi="['discount:privilegeCode:add']">
                    <a-icon type="plus" />新增兑换码
                </a-button>
            </div>

            <create-form ref="createForm" @ok="getList" />

            <a-table :loading="loading" :size="tableSize" rowKey="id" :columns="columns" :data-source="list"
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false"
                :bordered="tableBordered">

                <span slot="operation" slot-scope="text, record">

                    <a-divider type="vertical" v-hasPermi="['discount:privilegeCode:edit']" />

                    <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['discount:privilegeCode:edit']">
                        <a-icon type="edit" />修改
                    </a>

                    <a-divider type="vertical" v-hasPermi="['discount:privilegeCode:edit']" />
                </span>
            </a-table>

            <a-pagination class="ant-table-pagination" show-size-changer show-quick-jumper :current="queryParam.pageNum"
                :total="total" :page-size="queryParam.pageSize" :showTotal="total => `共 ${total} 条`"
                @showSizeChange="onShowSizeChange" @change="changeSize" />
        </a-card>
    </page-header-wrapper>
</template>

<script>
import { page, updateStatus } from '@/api/privilegeCode/privilegeCode'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

// ** 权限常量和 getItemName 函数已被移除 **

export default {
    name: 'PrivilegeCode',
    components: {
        CreateForm
    },
    mixins: [tableMixin],
    data() {
        return {
            list: [],
            selectedRowKeys: [],
            selectedRows: [],
            loading: false,
            total: 0,
            queryParam: {
                pageNum: 1,
                pageSize: 10
            },
            columns: [
                { title: 'ID', dataIndex: 'id', ellipsis: true, align: 'center' },
                { title: '兑换码', dataIndex: 'code', ellipsis: true, align: 'center' },
                // ** 权限项列直接使用 dataIndex 渲染后端返回的字符串 **
                { title: '权限列表', dataIndex: 'privilegeType', ellipsis: true, align: 'center' },
                {
                    title: '启用状态',
                    dataIndex: 'status',
                    // ellipsis: true,,
                    width: '15%',
                    align: 'center',
                    customRender: function (t, r, index) {
                        if (t == 0) {
                            return '启用'
                        } else if (t == 1) {
                            return '禁用'
                        }
                    }
                },
                { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
                { title: '操作', dataIndex: 'operation', width: '25%', scopedSlots: { customRender: 'operation' }, align: 'center' }
            ]
        }
    },
    created() {
        this.getList()
    },
    methods: {
        // ** methods 中不再包含 getItemName **
        /** * 页码改变的回调
             * @param {Number} page 改变后的页码
             * @param {Number} pageSize 当前每页条数
             */
        changeSize(page, pageSize) {
            this.queryParam.pageNum = page;
            this.getList();
        },

        /**
         * 每页条数改变的回调
         * @param {Number} current 当前页码
         * @param {Number} size 改变后的每页条数
         */
        onShowSizeChange(current, size) {
            this.queryParam.pageSize = size;
            this.queryParam.pageNum = 1; // 切换条数时通常重置回第一页
            this.getList();
        },
        getList() {
            this.loading = true
            page(this.queryParam).then(response => {
                this.list = response.data.records
                this.total = response.data.total
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },

        // ... (handleUpdateStatus, changeSize, onSelectChange 等方法保持不变)

        /** 状态更新操作 (标记已激活/禁用) */
        handleUpdateStatus(row, status) {
            const actionText = status === 2 ? '禁用' : '标记已激活';
            this.$confirm({
                title: `确认${actionText}该兑换码?`,
                content: `将兑换码 ${row.code} 设置为 ${actionText} 状态。`,
                onOk: () => {
                    return updateStatus({ id: row.id, status: status })
                        .then(() => {
                            this.getList()
                            this.$message.success(`${actionText}成功`)
                        })
                },
                onCancel() {
                    // 取消操作
                }
            })
        },
    }
}
</script>